import { NodeType } from '@amplify/amp-module';
import buttonStore from './button-store';
import InsightsNodeHandler from '../insights-node-handler';

export default class ButtonHandler extends InsightsNodeHandler {
  constructor(ctx, nodeType = NodeType.buttonGroup) {
    super(ctx, nodeType);

    if (!buttonStore.registered) {
      this.store.registerModule('buttonStore', buttonStore);
      buttonStore.registered = true;
    }
  }

  async handleNode(node, options = {}) {
    await super.handleNode(node, { ...options, handleStorage: false });

    if (this.unwatch) {
      this.unwatch();
    }

    const result = new Promise((resolve) => {
      this.unwatch = this.store.watch(
        (localstate) => localstate.buttonStore.button,
        (newValue) => {
          const subNode = node.subNodes?.[newValue.id];
          if (subNode) {
            if (node.storage) {
              this.store.dispatch('chatbotStore/addToStorage', { key: node.storage, data: newValue.value });
            }

            this.unwatch();

            const isQuestion = this.nodeType === NodeType.question;
            const topic = isQuestion ? 'question' : 'buttonGroup';
            const nodeTypeId = isQuestion ? 'questionId' : 'buttonId';

            this.trackResponseEvent(topic, {
              [nodeTypeId]: node.id,
              responseId: newValue.id,
              responseIndex: subNode.buttonTexts.indexOf(newValue.value),
            });

            resolve(this.store.getters['chatbotStore/nextNode'](`${node.id}_port_${newValue.id}`));
          }
        }
      );
    });

    return result;
  }
}
